import { Component, OnDestroy, OnInit } from '@angular/core';
import { IconService } from './services/utilities/icon.service';
import { VariableService } from './services/utilities/variables.service';
import { AlertService } from './services/utilities/alert.service';
import { AlertType, Icons, Colors, StorageObjects, SearchModules, Size } from './utilities/enum';
import { StorageService } from '@yellowtail-frontend/storage-service';
import { UserService } from './services/application/user.service';
import { ApplicationSummaryExtended, SnackBarAlert } from './models/component.model';
import { HelperService } from './services/utilities/helper.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SearchService } from '@utilServices/search.service';
import { MessageService } from '@appServices/message.service';
import { IMinimizedEmail } from './models/modal.model';
import { routerState } from './utilities/const';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    size = Size;
    icons = Icons;
    colors = Colors;
    title = 'cord-midoffice-frontend';
    alertType = AlertType;
    navigationSubscription: Subscription;
    minimizedEmails: IMinimizedEmail[] = [];

    constructor(
        private readonly _iconService: IconService,
        private readonly _variableService: VariableService,
        public readonly alertService: AlertService,
        private readonly _storageService: StorageService,
        private readonly _userService: UserService,
        private readonly _helperService: HelperService,
        private readonly _router: Router,
        private readonly _searchService: SearchService,
        private readonly _messageService: MessageService,
    ) {
        this._helperService.appendToken();

        this.navigationSubscription = this._router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            // if user navigates somewhere, clear search filter params for dossier finder component.
            const INDEX = this._searchService.searchModel.findIndex(e => e.module === SearchModules.DossierFinder);
            if (INDEX > -1) {
              this._searchService.searchModel.splice(INDEX, 1);
            }
          }

          if (event instanceof NavigationStart) {
            const nav = this._router.currentNavigation();
            routerState.refresh = nav.extras.state?.refresh ?? false;
          }
        });
        this.minimizedEmails = this._messageService.minimizedEmails;
    }

    ngOnInit(): void {
        this._iconService.registerIcons();
        this.alertService.hide();
        this._variableService.userToken = this._storageService.get<string>(StorageObjects.token);
        this._variableService.userID = this._storageService.get<string>(StorageObjects.userId);
        this._variableService.userType = this._storageService.get<string>(StorageObjects.userType);
        this._variableService.selectedApplicationId = this._storageService.get<string>(StorageObjects.selectedApplicationId);

        if (this._storageService.get<string>(StorageObjects.userProfile)) {
            this._userService.userProfile = JSON.parse(this._storageService.get<string>(StorageObjects.userProfile));
        }

        if (this._storageService.get<string>(StorageObjects.selectedDossier)) {
            this._variableService.selectedDossier = this._storageService.get<ApplicationSummaryExtended>(StorageObjects.selectedDossier);
        }
    }

    maximizeMessage(emailId: string): void {
      this._messageService.restoreMinimizedEmail(emailId);
    }

    ngOnDestroy(): void {
      if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
      }
    }

    remove(alert: SnackBarAlert): void {
        this.alertService.remove(alert);
    }
}
